import { useState } from 'react';
import s from './LogsFittingItemList.module.css';
import moment from 'moment';
import 'moment/locale/ru';
import {IDressingRequest} from '../../Logs/types';

const LogsFittingItemList = ({ log }: { log: IDressingRequest }) => {
    const [showAllDetails, setShowAllDetails] = useState(false);

    return (
        <div className={s.tableLog}>
            <tr>
                <th onClick={() => setShowAllDetails(!showAllDetails)} className={showAllDetails ? `${s.heading} ${s.open}`: s.heading}>
                    Переодевание от {moment(log.dateStartFitting).format('D MMMM YYYY, HH:mm')} пользователя: {log.userEmail}
                </th>
            </tr>
            {showAllDetails && ( 
                <tbody>
                    <div className={s.logСharacteristicsValue}>
                                <tr className={s.logСharacteristics}>
                                    <div className={s.dressingDetails}>
                                        <p><strong>ID запроса:</strong> {log.logId}</p>
                                        <p><strong>ID пользователя:</strong> {log.userId}</p>
                                        <p><strong>Дата начала:</strong> {log.dateStartFitting}</p>
                                        <p><strong>Дата окончания:</strong> {log.dateEndFitting}</p>
                                        
                                        {log.dateSendResults && (
                                            <p><strong>Дата отправки результатов:</strong> {log.dateSendResults}</p>
                                        )}
                                        
                                        {log.linkOriginalPhoto && (
                                            <p><strong>Ссылка на фото:</strong> {log.linkOriginalPhoto}</p>
                                        )}
                                        
                                        {log.roomGuid && (
                                            <p><strong>Room GUID:</strong> {log.roomGuid}</p>
                                        )}
                                        
                                        <p><strong>Одежда:</strong></p>
                                        <div className={s.clothesContainer}>
                                            {log.clothes.map((cloth, index) => (
                                                <div key={index} className={s.clothItem}>
                                                    <img 
                                                        src={cloth.thumbUrl} 
                                                        alt={cloth.name} 
                                                        className={s.clothImage}
                                                        loading="lazy"
                                                    />
                                                    <div className={s.nameblock}>{cloth.name}</div>
                                                    {cloth.color && (
                                                        <div>Цвет: {cloth.color}</div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                        
                                        {log.fittingPhotoUrl && (
                                            <div>
                                                <p><strong>Фото переодевания:</strong></p>
                                                <img 
                                                    src={`${log.fittingPhotoUrl}`} 
                                                    alt="Fitting preview" 
                                                    className={s.fittingImage}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </tr>
                            </div>
                </tbody>
            )}
        </div>
    );
};

export default LogsFittingItemList;